import { collectionSizeOrNull1v5nsm81on7r9 as collectionSizeOrNull } from './Iterables.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from './LinkedHashSet.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from './collectionJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import {
  addAll1k27qatfgp3k5 as addAll,
  convertToListIfNotCollection2y7m25iq802o0 as convertToListIfNotCollection,
} from './MutableCollections.mjs';
import { toSet2orjxp16sotqu as toSet } from './_Collections.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { equals2au1ep9vhcato as equals } from '../js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function plus(_this__u8e3s4, elements) {
  var tmp0_safe_receiver = collectionSizeOrNull(elements);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = _this__u8e3s4.get_size_woubt6_k$() + tmp0_safe_receiver | 0;
  }
  var tmp1_elvis_lhs = tmp;
  var result = LinkedHashSet().new_kotlin_collections_LinkedHashSet_wmub5z_k$(mapCapacity(tmp1_elvis_lhs == null ? imul(_this__u8e3s4.get_size_woubt6_k$(), 2) : tmp1_elvis_lhs));
  result.addAll_4lah1e_k$(_this__u8e3s4);
  addAll(result, elements);
  return result;
}
function plus_0(_this__u8e3s4, element) {
  var result = LinkedHashSet().new_kotlin_collections_LinkedHashSet_wmub5z_k$(mapCapacity(_this__u8e3s4.get_size_woubt6_k$() + 1 | 0));
  result.addAll_4lah1e_k$(_this__u8e3s4);
  result.add_utx5q5_k$(element);
  return result;
}
function minus(_this__u8e3s4, elements) {
  var other = convertToListIfNotCollection(elements);
  if (other.isEmpty_y1axqb_k$())
    return toSet(_this__u8e3s4);
  if (isInterface(other, KtSet())) {
    // Inline function 'kotlin.collections.filterNotTo' call
    var destination = LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$();
    var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      if (!other.contains_aljjnj_k$(element)) {
        destination.add_utx5q5_k$(element);
      }
    }
    return destination;
  }
  var result = LinkedHashSet().new_kotlin_collections_LinkedHashSet_2u8q9r_k$(_this__u8e3s4);
  result.removeAll_y0z8ch_k$(other);
  return result;
}
function minus_0(_this__u8e3s4, element) {
  var result = LinkedHashSet().new_kotlin_collections_LinkedHashSet_wmub5z_k$(mapCapacity(_this__u8e3s4.get_size_woubt6_k$()));
  var removed = false;
  // Inline function 'kotlin.collections.filterTo' call
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element_0 = _iterator__ex2g4s.next_20eer_k$();
    var tmp;
    if (!removed && equals(element_0, element)) {
      removed = true;
      tmp = false;
    } else {
      tmp = true;
    }
    if (tmp) {
      result.add_utx5q5_k$(element_0);
    }
  }
  return result;
}
//region block: exports
export {
  minus as minus165a8u1e0x1lu,
  minus_0 as minus27abgkurcn6u0,
  plus as plus1ogy4liedzq5j,
  plus_0 as plus18eogev54fmsa,
};
//endregion

//# sourceMappingURL=_Sets.mjs.map
